import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import QRCode from "react-qr-code";
import ban from '../img/math.png'

export default class Modaluserpay extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",//
   send_id:"",

   id_commentex:"",
   id_ex:"",
   id_expertbn:"",
   sentbackeditword:null,
   sentbackeditpdf:null,
   sentbackguarantee:null,
   filewordcomment_expertcheck:'',


   creck:'',
   payment_money:'',
   payment_ref1:'',
   payment_ref2	:'',
   barcode:'',
   payment_timeout:'',
  

   off:'',

}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleChange4 = this.handleChange4.bind(this);

this.toggle = this.toggle.bind(this);
this.toggle2 = this.toggle2.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.getpay = this.getpay.bind(this);
this.checktime = this.checktime.bind(this);
}

toggle2 = () => {
  this.setState({
    modal: !this.state.modal
  });
  window.location.reload();
// this.getpay()
// this.checktime()
 //this.props.selectex();

}

toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 this.getpay()
 this.checktime()
 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_bn: event.target.value});  }
checktime() { 

 
    const intervalId = setInterval(() => {

    //  const randomNum = Math.floor(Math.random() * 100) + 1;
    // console.log(randomNum)
    api.get('registercon/checkconfirm_money/'+this.state.payment_ref1)
    .then(res => {
      console.log(res.data.data);
      if (res.data.data.success === '1' && this.state.off === '') {
        console.log(res.data.data.success)
        const reff = this.state.payment_ref1.substring(3, 2);
      // const res.data.data.success
      //  this.toggle()
        clearInterval(intervalId);
        this.setState({ off: 'off'})

                if (this.props.typeac_id === 1) {

                                setTimeout(() => {
                                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                  //  datafrm.append("send_id", this.props.iduser);
                                    datafrm.append("id_send", this.props.id_send);
                                    datafrm.append("send_id", this.props.send_id);
                                    datafrm.append("send_statuspay", '2');
                                    datafrm.append("creck", res.data.data.success);
                                    datafrm.append("RecDate",res.data.data.RecDate);
                                    datafrm.append("BOOK", res.data.data.BOOK);
                                    datafrm.append("NO", res.data.data.NO);
                                     datafrm.append("Total", res.data.data.Total);
                                     datafrm.append("ref1", this.state.payment_ref1);
                                     datafrm.append("sign", this.props.payinout);
                                  api.post("registercon/updatepaylistforuser",datafrm,{
                                  headers: {
                                      'content-type': 'multipart/form-data'
                                  }
                                })
                              
                                .then(res => {
                                //  console.warn(res);
                                 // console.log("response: ", res)
                              
                                  if (res.data = '200') {
                                 
                                  Swal.fire({
                                    title: 'ชำระเงินลงทะเบียนเรียบร้อย',
                                    text: "Registration payment completed",
                                    icon: 'success',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'ตกลง'
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      this.toggle2()
                                      this.props.list()
                                    }
                                  })
                                  
                                  }else{
                                    message.error("ชำระเงินไม่สำเร็จ!")
                                  }
                              
                                })
                              }, 2000);



                }else if (this.props.typeac_id === 2) {
                            setTimeout(() => {
                              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                            //  datafrm.append("send_id", this.props.iduser);
                              datafrm.append("id_send", this.props.id_send);
                              datafrm.append("send_id", this.props.send_id);
                              datafrm.append("send_statuspay", '2');
                              datafrm.append("creck", res.data.data.success);
                              datafrm.append("RecDate",res.data.data.RecDate);
                              datafrm.append("BOOK", res.data.data.BOOK);
                              datafrm.append("NO", res.data.data.NO);
                              datafrm.append("Total", res.data.data.Total);
                              datafrm.append("ref1", this.state.payment_ref1);
                            api.post("registercon/updatepaylistrticlesmforuser",datafrm,{
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                          })
                        
                          .then(res => {
                            if (res.data = '200') {
                          
                            Swal.fire({
                              title: 'ชำระเงินลงทะเบียนเรียบร้อย',
                              text: "Registration payment completed",
                              icon: 'success',
                              showCancelButton: false,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: 'ตกลง'
                            }).then((result) => {
                              if (result.isConfirmed) {
                                 this.toggle2()
                                 this.props.list()
                              }
                            })
                            
                            }else{
                              message.error("ชำระเงินไม่สำเร็จ!")
                            }
                        
                          })
                        }, 2000);
                }else{
                        setTimeout(() => {
                          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        //  datafrm.append("send_id", this.props.iduser);
                          datafrm.append("id_send", this.props.id_send);
                          datafrm.append("send_id", this.props.send_id);
                       //   datafrm.append("send_statuspay", '2');
                          datafrm.append("creck", res.data.data.success);
                          datafrm.append("RecDate",res.data.data.RecDate);
                          datafrm.append("BOOK", res.data.data.BOOK);
                          datafrm.append("NO", res.data.data.NO);
                          datafrm.append("Total", res.data.data.Total);
                          datafrm.append("ref1", this.state.payment_ref1);
                          datafrm.append("sign", this.props.payinout);
                        api.post("registercon/updatepaylistlistenforuser",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                      })
                    
                      .then(res => {
                        if (res.data = '200') {
                      
                        Swal.fire({
                          title: 'ชำระเงินลงทะเบียนเรียบร้อย',
                          text: "Registration payment completed",
                          icon: 'success',
                          showCancelButton: false,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'ตกลง'
                        }).then((result) => {
                          if (result.isConfirmed) {
                            this.toggle2()
                            this.props.list()
                          }
                        })
                        
                        }else{
                          message.error("ชำระเงินไม่สำเร็จ!")
                        }
                    
                      })
                     }, 2000);
                }


      }else{
        console.log(res.data.data.success)
      }

    //  this.setState({ payment_money: res.data.data.payment_money})
    
     
    }) 

      if (this.state.off ==='off') {
      clearInterval(intervalId);
      }
     //clearInterval(intervalId);
      }, 1000);
    
    //  clearInterval(refreshIntervalId);
    //clearInterval(intervalId);
    // console.log(intervalId)

 }

 
 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);

       this.setState({ id_send:this.props.id_sendarticle,
                          send_id:this.props.send_id,
                          price_typeregister:this.props.price_typeregister,
                    //    id_expertbn:this.props.id_experten,
                    //    filewordcomment_expertcheck:this.props.filewordcomment_expert,
        })


        // setTimeout(() => {
          
        //      api.get('registercon/checkregister_money/'+this.props.id_send+'/'+this.props.send_id+'/1')
        //      .then(res => {
        //        console.log(res);
        //       // this.setState({ commentuser: res.data})
              
        //      }) 
        //    }, 400);
  }

  getpay() {
  
  

           setTimeout(() => {
          
             api.get('registercon/checkregister_money/'+this.props.id_send+'/'+this.props.send_id+'/'+this.props.typeac_id+'/'+this.props.price_typeregister)
             .then(res => {
           //    console.log(res.data.data.payment_money);
               this.setState({ payment_money: res.data.data.payment_money})
               this.setState({ payment_ref1: res.data.data.payment_ref1})
               this.setState({ payment_ref2: res.data.data.payment_ref2})
               this.setState({ payment_timeout: res.data.data.payment_timeout})
               this.setState({ barcode: res.data.data.barcode})
               	
              
             }) 
           }, 400);


  }



  handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({sentbackeditword: event.target.files[0]});  }
  handleChange3(event) {    this.setState({sentbackeditpdf: event.target.files[0]});  }
  handleChange4(event) {    this.setState({sentbackguarantee: event.target.files[0]});  }


  handleSubmit() {
    
    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_sendarticle", this.state.id_send);
      datafrm.append("id_commentex", this.state.id_commentex);
      datafrm.append("id_expertex", this.state.id_ex);
      datafrm.append("id_experten", this.state.id_expertbn);
      datafrm.append("sentbackeditword", this.state.sentbackeditword);
      datafrm.append("sentbackeditpdf", this.state.sentbackeditpdf);
      datafrm.append("date_sentexpert", dates);
      datafrm.append("filewordcomment_expertcheck", this.state.filewordcomment_expertcheck);
      
      api.post("registercon/updatearticleeditex",datafrm,{
        headers: {
            'content-type': 'multipart/form-data'
        }
      })

   .then(res => {
   
  
            if (res.data === '200') {
                Swal.fire({
                title: 'บันทึกไฟล์ปรับแก้ไขสำเร็จ',
                text: "Successfully saved modified file.",
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง'
                  }).then((result) => {
                      if (result.isConfirmed) {
                          this.props.list()
                          this.toggle()
                      }
                  })
            
            }else{
                    message.error("อัพโหลไฟล์ไม่สำเร็จ!")
            }
        
            
  })
}, 400);

 
  }

  

    render() {
      //  console.log(this.state.filewordcomment_back)

        return (
            <MDBContainer className='text-left'>
            <MDBBtn color="mdb-color" onClick={this.toggle} size='sm'><MDBIcon icon="dollar-sign" />  ชำระเงินค่าลงทะเบียนบทความ</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}  disableBackdrop="true">
              <MDBModalHeader>
       <MDBIcon fas icon="dollar-sign" />    ชำระเงินบทความ
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <br/>
              <div>
              <br/>
              <div style={{ height: "auto", margin: "0 auto", maxWidth: 150, width: "100%" }}>
                <QRCode
                    size={456}
                    style={{ height: "auto", maxWidth: "100%", width: "100%", fgColor:"#2471a3" }}
                    value={this.state.barcode}
                    viewBox={`0 0 256 256`}
                   // fgColor='#00008B'
                  // value='|099400049424619 6710002001 67123086729 10000'
                />
                </div>
                <br/>
                <h4 className="font-weight-bold text-center mt-3">จำนวน {this.state.payment_money} บาท</h4>
                <p>ref1 : {this.state.payment_ref1} <br/>ref2 : {this.state.payment_ref2	}<br/>ชำระเงินภายในวันที่ : {this.state.payment_timeout}</p>

                {this.state.creck === '1'?<>
                <p></p>
                </>:<>
                <p></p>
                </>}
                {/* <p>ref2 : {this.state.payment_ref2	}</p>
                <p>ชำระเงินภายในวันที่ : {this.state.payment_timeout}</p> */}


                {/* // fgColor='#2471a3' */}
              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
              {/* <p>อัพโหลดไฟล์แบบประเมิน .pdf</p> */}
                {/* <MDBInput   group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}

                            {/* <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความที่ปรับแก้ไขแล้ว <MDBIcon icon="file-word" /> .docx</strong></label>
                             
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        required />
                            </div>
                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div> */}
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
                 {/* {this.state.sentbackeditword == null  ? <><MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> :<>  <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> } */}
                <MDBBtn color="secondary" onClick={this.toggle2}>ปิด</MDBBtn>
               
              
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}


